// A csempe-katalógus ikon-neve (`@atlas/shared`) → Heroicon-komponens. Külön fájl, hogy a regiszter-modul csak komponenst exportáljon.
import { type DashboardTileDef } from '@atlas/shared';
import {
  BanknotesIcon,
  BookmarkIcon,
  BuildingOffice2Icon,
  CakeIcon,
  CalendarDaysIcon,
  ExclamationTriangleIcon,
  HomeModernIcon,
  InboxStackIcon,
  PencilSquareIcon,
  ReceiptPercentIcon,
  Squares2X2Icon,
  TicketIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';
import { type ComponentType, type SVGProps } from 'react';

type IconType = ComponentType<SVGProps<SVGSVGElement>>;

const ICONS: Record<string, IconType> = {
  BookmarkIcon,
  BuildingOffice2Icon,
  UsersIcon,
  TicketIcon,
  BanknotesIcon,
  ReceiptPercentIcon,
  CalendarDaysIcon,
  CakeIcon,
  ExclamationTriangleIcon,
  InboxStackIcon,
  PencilSquareIcon,
};

/**
 * A csempe ikonja a szerkesztőben / galériában. A katalógus ikon-neve szerint; egyetlen szándékos eltérés: a
 * „Fiókok" KPI a lapon mindig is a `HomeModernIcon`-t viselte (a fiók nem „felhasználó"), a szerkesztő ezt követi.
 */
export function tileIcon(def: DashboardTileDef): IconType {
  if (def.id === 'kpi.accounts') return HomeModernIcon;
  return ICONS[def.icon] ?? Squares2X2Icon;
}
